import { CSSProperties } from 'react';
import styled from 'styled-components';
import { Box } from '..';
import { getColor } from '../../styles/mixins';
import { ColumnNodeStyleI, FieldPanelI } from '../../types/column';
import { Cross2Icon } from '@modulz/radix-icons';

interface DeleteIconProps {
  showDeleteColumnIcon: boolean;
}

export const targetHandleStyleA: CSSProperties = {
  background: getColor('yellow'),
  height: '24px',
  width: '24px',
  zIndex: -1,
  top: '-12px',
};

export const sourceHandleStyleA: CSSProperties = {
  background: getColor('green'),
  height: '16px',
  width: '16px',
  marginTop: '-10px',
  marginRight: '-4px',
  zIndex: -1,
};

export const ColumnNodeStyle = styled(Box)<ColumnNodeStyleI>`
  border: 3px solid
    ${({ selectedNode }: ColumnNodeStyleI) =>
      selectedNode ? getColor('gray', 900) : 'transparent'};
  display: block;
  font-weight: 500;
  font-size: 22px;
  cursor: pointer;
  color: white;
  width: auto;
  height: auto;
  min-width: 200px;
  min-height: 40px;
  border-radius: 82px;
  z-index: 2;
  background-color: ${getColor('gray', 800)};
`;

export const FieldPanel = styled(Box)<FieldPanelI>`
  border-radius: 0 0 8px 8px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${({ panelColor }) => getColor(panelColor, 300)};
  height: 20px;
  width: 108px;
  z-index: 10;
  box-shadow: 2px 2px 6px ${getColor('gray', 400)};
`;

export const Circle = styled(Box)`
  width: 12px;
  height: 12px;
  border-radius: 10px;
  background-color: ${(props) =>
    props.color !== '' ? props.color : `${getColor('gray', 100)}`};
`;

export const DeleteNode = styled(Box)`
  height: 20px;
  width: 20px;
  color: ${getColor('gray', 0)};
  margin-bottom: -16px;
  margin-left: -4px;
  margin-top: -4px;
  cursor: pointer;
`;

export const DeleteIcon = styled(Cross2Icon)`
  height: 20px;
  width: 20px;
  background-color: ${getColor('red')};
  border-radius: 12px;
  padding: 2px;
  visibility: ${({ showDeleteColumnIcon }: DeleteIconProps) =>
    showDeleteColumnIcon ? 'visible' : 'hidden'};
`;
